import { ErrorCodes } from '../../enum/error-code.enum';

export class ErrorDecoderHelper {
  static getCodeErro(error: any) {
    if (!error) {
      return ErrorCodes.UNKNOWN;
    }
    if (error['status'] === 404) {
      return ErrorCodes.NOT_FOUND_URL;
    }
    if (error['type'] === 'invalid_nonce_in_state') {
      return ErrorCodes.INVALID_LOGIN_SCREEN;
    }
    if (/^.*\.well-known\/openid-configuration.*$/gm.test(error['url']) && (error['status'] === 407 || error['statusCode'] === 407)) {
      return ErrorCodes.INVALID_CLIENT_PROXY;
    }
    if (/^.*\.well-known\/openid-configuration.*$/gm.test(error['url']) && (error['status'] >= 500 || error['statusCode'] >= 500)) {
      return ErrorCodes.ERROR_CIAM;
    }
    if (/^.*charon.*$/gm.test(error['url']) && (error['status'] === 407 || error['statusCode'] === 407)) {
      return ErrorCodes.INVALID_CHARON_PROXY;
    }
    if (
      /^.*charon.*$/gm.test(error['url']) &&
      (error['status'] >= 500 || error['statusCode'] >= 500 || error['status'] === 0 || error['statusCode'] === 0)
    ) {
      return ErrorCodes.INVALID_CHARON_TOKEN_RECOVERY;
    }
  }

  static getCorrelationId(error: any): string | undefined {
    if (!error?.correlationId) {
      return;
    }
    return error['correlationId'];
  }
}
